module.exports = __webpack_public_path__ + "img/PlusIcon.fdd545f4.svg";